// RoleAccess.ts
import { Role } from "../types/User";


export const RoleAccess: Record<Role, string[]> = {
  [Role.USER]: ['BetFinder', 'BetJuicer', 'CommunityBoard', 'AccountSettings', 'PricingPage','Util','SureBets','SureBetSection','SuggestionWall','SuggestionComp' ],
  // KalshiOddsView controls visibility of post-fee Kalshi/Polymarket odds
  // chips and the inline "Place bet"-shaped pill (without click). Splitting
  // this from KalshiTrading lets paid users see real prices on prediction
  // markets while keeping order placement admin-gated.
  [Role.BRONZE]: ['CreateBettingGroup', 'AccountSettings','PositiveEV','Arbitrage','KalshiOddsView'],
  [Role.SILVER]: ['ParlayBuilder','BpiBets','PositiveEV','Arbitrage','KalshiOddsView'],
  // LiveMode (in-play odds for arb / +EV) is Gold+ only. The on-demand
  // refresh path costs a vendor credit per click per sport, so we
  // restrict it to the highest tier and the backend enforces the same
  // gate (LiveOddsRequestHandler).
  // PredictionTraders (the prediction-market whale tracker) and SharpMoney
  // (the exchange-wall board) are Gold+; ADMIN inherits both via the role
  // hierarchy. SharpMoney opened to Gold on 2026-10-12 off the public
  // /performance/sharp track record; the backend gate on
  // /api/v1/internal/smart-money/candidates moved to GOLD at the same time.
  [Role.GOLD]: ['LiveMode','PositiveEV','Arbitrage','KalshiOddsView','PredictionTraders','SharpMoney'],
  // BetAgent gates the entire screen-control extension surface
  // (Send-to-agent buttons, status drawer, intent emission). Admin-
  // only because the agent drives third-party sportsbooks under
  // the user's session — ToS gray area, credential handling, and
  // order placement risk all warrant an admin-only bar until the
  // surface is hardened.
  [Role.ADMIN]: ['Util','PositiveEV','Arbitrage','KalshiOddsView','KalshiTrading','BetAgent','PredictionTraders','SharpMoney'],
}
